import React from "react";
import { useTheme } from "@mui/material/styles";

// ── Icons ─────────────────────────────────────────────────────────────────────
const ExportIcon = ({ color }) => (
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
    <path d="M8 1v9M4 7l4 4 4-4M2 13h12"
      stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// ── ExportButton ──────────────────────────────────────────────────────────────
export const ExportButton = ({ onClick, label = "Export", disabled = false }) => {
  const theme  = useTheme();
  const t      = theme.custom;
  const isDark = theme.palette.mode === "dark";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.background = isDark
            ? "rgba(255,255,255,0.05)"
            : "rgba(3,81,77,0.05)";
          e.currentTarget.style.color      = t.text;
          e.currentTarget.style.borderColor = t.accent;
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background  = "transparent";
        e.currentTarget.style.color       = t.text2;
        e.currentTarget.style.borderColor = t.border2;
      }}
      style={{
        height: 32, padding: "0 14px", borderRadius: 8,
        border: `1px solid ${t.border2}`,
        background: "transparent",
        color: disabled ? t.text3 : t.text2,
        fontSize: 12, fontWeight: 500,
        cursor: disabled ? "not-allowed" : "pointer",
        display: "inline-flex", alignItems: "center", gap: 6,
        transition: "all 0.15s",
        opacity: disabled ? 0.5 : 1,
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <ExportIcon color={disabled ? t.text3 : t.text2} />
      {label}
    </button>
  );
};